import { createSlice } from '@reduxjs/toolkit'

export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    keyword: '',
  },
  reducers: {
    setKeyword: (state, action) => {
      state.keyword = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setKeyword } = searchSlice.actions

export default searchSlice.reducer